var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddShoppingCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1689_3986",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1689_3986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16732 7.49967V4.99967H6.66732V3.33301H9.16732V0.833008H10.834V3.33301H13.334V4.99967H10.834V7.49967H9.16732ZM5.83398 18.333C5.37565 18.333 4.98329 18.1698 4.6569 17.8434C4.33051 17.517 4.16732 17.1247 4.16732 16.6663C4.16732 16.208 4.33051 15.8156 4.6569 15.4893C4.98329 15.1629 5.37565 14.9997 5.83398 14.9997C6.29232 14.9997 6.68468 15.1629 7.01107 15.4893C7.33746 15.8156 7.50065 16.208 7.50065 16.6663C7.50065 17.1247 7.33746 17.517 7.01107 17.8434C6.68468 18.1698 6.29232 18.333 5.83398 18.333ZM14.1673 18.333C13.709 18.333 13.3166 18.1698 12.9902 17.8434C12.6638 17.517 12.5007 17.1247 12.5007 16.6663C12.5007 16.208 12.6638 15.8156 12.9902 15.4893C13.3166 15.1629 13.709 14.9997 14.1673 14.9997C14.6257 14.9997 15.018 15.1629 15.3444 15.4893C15.6708 15.8156 15.834 16.208 15.834 16.6663C15.834 17.1247 15.6708 17.517 15.3444 17.8434C15.018 18.1698 14.6257 18.333 14.1673 18.333ZM0.833984 3.33301V1.66634H3.56315L7.10482 9.16634H12.9382L16.1882 3.33301H18.084L14.4173 9.95801C14.2645 10.2358 14.0597 10.4511 13.8027 10.6038C13.5458 10.7566 13.2645 10.833 12.959 10.833H6.75065L5.83398 12.4997H15.834V14.1663H5.83398C5.20898 14.1663 4.73329 13.8955 4.4069 13.3538C4.08051 12.8122 4.0701 12.2636 4.37565 11.708L5.50065 9.66634L2.50065 3.33301H0.833984Z",
    fill: "#DADADA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddShoppingCart);
export default __webpack_public_path__ + "static/media/add_shopping_cart.639c7ba932f275b9ce0eb8f783e310fd.svg";
export { ForwardRef as ReactComponent };